import { makeStyles, Typography } from '@material-ui/core';
import { useApi, identityApiRef } from '@backstage/core-plugin-api';
import useAsync from 'react-use/esm/useAsync';
import {
  boschBlue,
  boschWhite,
} from '../../modules/theme/boschColors';

const useStyles = makeStyles(theme => ({
  banner: {
    background: `linear-gradient(135deg, ${boschBlue[20]} 0%, ${boschBlue[40]} 55%, ${boschBlue[50]} 100%)`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(4),
    color: boschWhite,
    position: 'relative',
    overflow: 'hidden',
    marginBottom: theme.spacing(3),
    minHeight: 140,
  },
  bannerShape: {
    position: 'absolute',
    right: -60,
    top: -60,
    width: 320,
    height: 320,
    borderRadius: '50%',
    background:
      'radial-gradient(circle at center, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0) 70%)',
    pointerEvents: 'none',
  },
  bannerAccent: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
    height: 4,
    background: `linear-gradient(90deg, ${boschBlue[60]} 0%, ${boschBlue[50]} 50%, ${boschBlue[40]} 100%)`,
  },
  greeting: {
    fontSize: '1.75rem',
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
    position: 'relative',
    zIndex: 1,
  },
  subtitle: {
    fontSize: '1rem',
    opacity: 0.9,
    position: 'relative',
    zIndex: 1,
  },
}));

function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
}

export const WelcomeBanner = () => {
  const classes = useStyles();
  const identityApi = useApi(identityApiRef);

  const { value: profile } = useAsync(async () => {
    return identityApi.getProfileInfo();
  }, [identityApi]);

  const displayName = profile?.displayName ?? 'there';

  return (
    <div className={classes.banner}>
      <div className={classes.bannerShape} />
      <Typography variant="h4" component="h1" className={classes.greeting}>
        {getGreeting()}, {displayName}!
      </Typography>
      <Typography variant="body1" className={classes.subtitle}>
        Welcome to Digital Factory Backstage
      </Typography>
      <div className={classes.bannerAccent} />
    </div>
  );
};
